import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import HouseProgressBar from "@/components/subcomponents/HouseProgressBar";
import { useTitle } from "@/components/provider/TitleProvider";
import { useSubHeader } from "@/components/provider/SubHeaderProvider";
import TransitionLink from "../../TransitionLink";

const DoubleBoost = () => {
  const { setTitle } = useTitle();
  const { setSubHeader } = useSubHeader();

  useEffect(() => {
    setTitle("BuySooner - Double Boost", "center");
    setSubHeader(
      <div className="mt-12 text-center pb-4">
        <TransitionLink
          to="/double-boost/calculator"
          onClick={() => setSubHeader(<></>)}
          className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
        >
          See calculation for your home
        </TransitionLink>
      </div>,
    );
  }, []);

  useEffect(() => {
    const body = document.querySelector("#root")!;
    body.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-5 sm:grid-rows-[auto_auto_auto] gap-x-4 max-w-5xl mx-auto py-8">
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Deposit and monthly home loan repayments</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={70}
          fillColor="#2464B3"
          baseColor="#57CB8F"
          shares={{
            variant: 2,
            percentageOne: 70,
            percentageTwo: 30,
          }}
          shareLabels={{
            labelOne: "Owner",
            labelTwo: "BuySooner",
          }}
        />
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          BuySooner will top up what savings you have, you can afford the home of your dreams now. We'll then help with
          monthly repayments until you are earning more.
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Shared Ownership</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={80}
          fillColor="#2464B3"
          baseColor="#57CB8F"
          shares={{
            variant: 2,
            percentageOne: 90,
            percentageTwo: 10,
          }}
          shareLabels={{
            labelOne: "Owner",
            labelTwo: "10% BuySooner",
          }}
        />
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          You can contribute to buying back our share monthly, or buy it all at once with a refinance, which we will
          help you get.
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">100% Self Owned</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={100}
          fillColor="#2464B3"
          baseColor="#2E3745"
          shares={{
            variant: 3,
            percentageOne: 100,
            percentageTwo: 0,
          }}
        />
      </div>
    </div>
  );
};

DoubleBoost.propTypes = {};

export default DoubleBoost;
